import { Link, LinkOptions } from "@/components/link";
import { PATH_PAYROLL_INSPECTION } from "@/constants";
import { InspectIcon } from "lucide-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router-dom";
import { usePayrollParams } from "../hooks/usePayrollParams";
import { usePayrollPermissions } from "../hooks/usePayrollPermissions";

interface PayrollInspectLinkProps {
  options?: LinkOptions;
}

export const PayrollInspectLink = memo(
  ({ options }: PayrollInspectLinkProps) => {
    const { t } = useTranslation();
    const { payrollId } = usePayrollParams();
    const permissions = usePayrollPermissions();

    return (
      <Link
        to={generatePath(PATH_PAYROLL_INSPECTION, {
          payrollId,
        })}
        options={options}
      >
        <InspectIcon className="w-5 h-5 mr-1" />
        {t(
          permissions.canUpdateAggregate
            ? "payrolls.inspectPayroll.link"
            : "payrolls.inspectPayroll.linkReadOnly",
        )}
      </Link>
    );
  },
);
